import { useEffect, useRef, useState } from 'react'
import "./filter_style.css"
import DateRange from './dateRange/DateRange';
import * as React from 'react'
import { getModelWiseParams } from '../../services/util/backdatedParams';

let filter_obj: any = {
    'start_date': false,
    'end_date': false,
    'Current_contract': true,
    'No_of_months': false,
};

interface FilterProps {
    setFilter: any,
    setFilterData: any,
    filterData: any,
    versions: any,
    setFilterFinalObject: any,
    dateFilter: any,
    setDateFilter: any,
    setCurrContractDiv: any,
    type:any,
    privilegedCodeAndSymbol:any
}


const Filter: React.FC<FilterProps> = ({ type, setFilter, setFilterData, filterData, versions, setFilterFinalObject, dateFilter, setDateFilter, setCurrContractDiv,privilegedCodeAndSymbol }: any) => {

    const [filterVersion, setFilterVersion] = useState<boolean>(true);
    const [filterTimeFrame, setFilterTimeFrame] = useState<boolean>(false);
    const [state, setstate] = useState<boolean>(true)

    const handleVersionclick = () => {
        setFilterVersion(true);
        setFilterTimeFrame(false);
    }

    const handleTimeFrameclick = () => {
        setFilterTimeFrame(true);
        setFilterVersion(false);
    }
    versions = versions.sort((previous:any, next:any) =>
        previous.slice(3,previous.length).localeCompare(next.slice(3,next.length)));

    const handleApply = (e: any) => {
        e.preventDefault();
        const model_version: any = { 'All': filterData['All'] }
        versions?.map((version: any, index: any) => (
            Object.assign(model_version, { [version]: filterData[version] })
        ))
        Object.assign(filter_obj, { model_version })
        setFilterFinalObject({ ...filter_obj, ...model_version })
        setFilter(false)
        setCurrContractDiv(filter_obj['Current_contract'])
    }

    const changeStateHandler = () => {
        setFilterData((prevState: any) => ({ ...prevState, 'All': !prevState['All'] }))
        if (filterData['All']) {
            versions.map((version: any) => (
                setFilterData((prevState: any) => ({ ...prevState, [version]: false }))
            ))
        }
        else {
            versions.map((version: any) => (
                setFilterData((prevState: any) => ({ ...prevState, [version]: true }))
            ))
        }
    }

    const ref = useRef<any>(null);

    useEffect(() => {
        let result: boolean = true;
        versions.map((version: any, index: any) => (
            result = result && filterData[version]
        ))
        if (result) {
            setFilterData((prevState: any) => ({ ...prevState, 'All': true }))
        }
        else {
            (result === undefined ? false : !result) && setFilterData((prevState: any) => ({ ...prevState, 'All': false }))
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state])

    return (
        <div ref={ref} className='mainFilterDiv '>
            <div className='filter_icon '></div>
            <div className='innerDiv '>
                <div className='left_div '>
                    <div className='sideName '>
                        <span className={` ${filterVersion ? "selected" : ""}`} onClick={handleVersionclick}>Version</span>
                        <span className={` ${filterTimeFrame ? "selected" : ""}`} onClick={handleTimeFrameclick}>Date Range</span>
                    </div>
                </div>
                <div className='right_div '>

                    {filterVersion && <div className='formDiv '>
                        <form className="versionform " action="">
                            <label htmlFor="All">
                                <input

                                    type="checkbox"
                                    id="All"
                                    name="All"
                                    value=""
                                    checked={filterData['All']}
                                    onClick={changeStateHandler}
                                />
                                ALL
                            </label>

                            {versions.map((version: any, index: any) => (
                                <label key={index} htmlFor={version}>
                                    <input
                                        type="checkbox"
                                        id={version}
                                        name={version}
                                        value=""
                                        checked={filterData[version]}
                                        onClick={() => {
                                            setFilterData((prevState: any) => ({ ...prevState, [version]: !prevState[version] }))
                                            setstate(!state)
                                        }}
                                    />
                                    {(version.slice(0,3)==='QEB')? privilegedCodeAndSymbol[version].split('_')[0] :(version.slice(1,3)==='ES')?privilegedCodeAndSymbol[version]:getModelWiseParams(version)}
                                    {/* {version.slice(0,3)==='QEB'?version.slice(3):version.slice(1,3)==='ES'?privilegedCodeAndSymbol[version]:getModelWiseParams(version)} */}
                                </label>
                            ))}
                        </form>
                    </div>}

                    {filterTimeFrame &&
                        <div className='timeFrameDiv '>
                            <DateRange dateFilter={dateFilter} setDateFilter={setDateFilter} filter_obj={filter_obj} type={type} />
                        </div>
                    }

                    <div className='reset_apply_Btn '>
                        <button onClick={()=>setFilter(false)}><span>Cancel</span></button>
                        <button onClick={handleApply}><span>Apply</span></button>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default Filter
